import React, { useState } from "react";
import { GenericDiv, Input, Label, PopupForm } from "../../../common/Style";

const Closeness = ({ func, init }) => {
  const [data, setData] = useState("");
  return (
    <PopupForm onClick={(e) => e.stopPropagation()}>
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <Label>עריכת קירבה</Label>
        <Input
          onChange={(e) => setData(e.target.value)}
          placeholder="כתבו כאן..."
        />
        <GenericDiv
          onClick={() => func({ closeness: data }, init)}
          style={{ margin: "10px auto", marginTop: "30px" }}
        >
          שמירה
        </GenericDiv>
      </div>
    </PopupForm>
  );
};

export default Closeness;
